<template>
<div class="z-agreement">
	<header class="z-login-header">
	{{$t('风险提示')}}
	</header>
	<div class="z-agreement-content" :style="{height: eh+'px'}" v-html="agreement"></div>
	<div class="z-flex z-agreement-btns">
		<div @click="$router.push({name:'register',params:$route.params})">{{$t('确认')}}</div>
	</div>
</div>
</template>

<script>
	export default {
		name: 'agreement',
		data() {
			return {
				agreement:'',
				eh:0
			}
		},
		created() {
			this.get('api/index/protocol.html', {}).then((res) => {
				this.agreement = res.data.content
			})
		},
		mounted(){
			let h = document.body.clientHeight
			this.eh = h-120
		},
		methods: {
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-login-header{
	display: flex;
	align-items: center;
	justify-content:center;
	font-weight:500;
	font-size:18px; 
	height: 40px;
}
.z-agreement {
	color: white;
	height: 100%;
	background-color: #31343B
}
.z-agreement-content {
	margin:15px;
	background:#575757;
	padding: 10px;
	overflow-y: scroll;
}
.z-agreement-btns>div{
	padding: 5px 15px;
	border-radius: 5px;
	font-size: 16px;
	font-weight: 500px;
	background: #FF9700;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/agreement.vue